import React from 'react';
import Form from "react-bootstrap/Form"
import SelectSlider from "./SelectSlider";
import ExpandedChoice from "./ExpandedChoice";

function Select(props) {
    if (props?.expandedStyle){
        return <ExpandedChoice {...props}/>
    }
    props.elementProps.onChange = function (e) {
        let value = e.target.value
        switch(value){
            case "true": value = true; break
            case "false": value =  false; break
            default:
        }
        if (!isNaN(value) && typeof value !== "boolean"){
            value =  parseInt(value)
        }
        props.setAnswer(value)
        return true
    }
    // change to controlled
    // const {defaultValue,...rest} = props.elementProps
    // rest.value = defaultValue
    return (
        <Form.Select aria-label="Choose an option" {...props.elementProps}>
            {[undefined,null,''].includes(props.elementProps.defaultValue) && <option value=''>Choose ...</option>}
            {
                props.choices.map(choice=>{
                    return (<option key={choice.value} value={choice.value}>{choice.text}</option>)
                })
            }
        </Form.Select>
    );
}
// function ExpandedSelect(props) {
//     return <SelectSlider
//         elementProps={{
//             defaultValue: props.elementProps.defaultValue,
//             options: [
//                 {value: "UNKNOWN", text: "I dont know"},
//                 {value: "A", text: "A"},
//                 {value: "B", text: "B"},
//                 {value: "C", text: "C"},
//                 {value: "D", text: "D"},
//                 {value: "E", text: "E"},
//                 {value: "F", text: "F"},
//                 {value: "G", text: "G"}
//             ]
//         }}
//         label={props.label}
//         setAnswer={props.setAnswer}
//     />
// }
export default Select;
// <div className="amplify-field-group__field-wrapper amplify-field-group__field-wrapper--horizontal"
//      data-orientation="horizontal"><input aria-invalid="false" className="amplify-input amplify-field-group__control"
//                                           id="amplify-id-:rbg:" type="text" value="Dublin"></div>